export const isPositiveNumber = (value: any) => {
  let numValue = Number(value);
  return (
    typeof numValue === 'number' && isFinite(numValue) && numValue > 0
  );
};
